<template>
  <validation-observer
    v-slot="{ handleSubmit }"
    tag="div"
    class="project-form-tab"
  >
    <tab
      title="Setup the basics"
      number="1"
      :active="activeTab == 0"
      :done="done[0] || false"
      @click:header="changeTab(0)"
    >
      <validation-observer ref="tab-0" tag="div">
        <div class="columns is-8 is-variable">
          <div class="column is-4">
            <label class="label">Preview</label>
            <div class="project-card preview">
              <div
                class="background"
                :class="previewProjectColor"
                :style="previewProjectImage"
              ></div>
              <div class="text-group">
                <div class="title">{{ model.name }}</div>
                <div class="subtitle">Project SubTitle</div>
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <validation-provider v-slot="{ errors, failed }" rules="required">
                <label class="label">Name</label>
                <div class="control">
                  <input
                    v-model="model.name"
                    class="input"
                    type="text"
                    :class="{ 'is-danger': failed }"
                  />
                </div>
                <p class="help is-danger">{{ errors[0] }}</p>
              </validation-provider>
            </div>
            <div class="field">
              <label class="label">Association</label>
              <div class="control">
                <validation-provider
                  v-slot="{ errors, failed }"
                  rules="required"
                >
                  <div class="select" :class="{ 'is-danger': failed }">
                    <select v-model="model.groupID">
                      <option
                        v-for="r in associatedGroup"
                        :key="r.groupID"
                        :value="r.groupID"
                        :disabled="r.disabled"
                        v-html="r.name"
                      >
                      </option>
                    </select>
                  </div>
                  <p class="help is-danger">{{ errors[0] }}</p>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">Customize your cover image</label>
              <div class="control">
                <div class="cover-picker">
                  <div
                    class="cover-picker-item is-default"
                    :class="{
                      'is-selected':
                        !model.coverHtmlColor1 && !model.coverImageContentUrl
                    }"
                    @click="pickColor(0)"
                  ></div>
                  <template v-for="index in 5">
                    <div
                      :key="index"
                      class="cover-picker-item"
                      :class="[
                        'is-gradient-' + index,
                        model.coverHtmlColor1 == index ? 'is-selected' : ''
                      ]"
                      @click="pickColor(index)"
                    ></div>
                  </template>

                  <!--div class="cover-picker-item is-default"></div>
                  <div class="cover-picker-item is-gradient-1"></div>
                  <div class="cover-picker-item is-gradient-2"></div>
                  <div class="cover-picker-item is-gradient-3"></div>
                  <div class="cover-picker-item is-gradient-4"></div>
                  <div class="cover-picker-item is-gradient-5"></div-->
                </div>
              </div>
            </div>
            <div class="field">
              <label class="label">Upload file</label>
              <div class="control">
                <div class="file has-name is-fullwidth is-right">
                  <label class="file-label">
                    <input
                      ref="fileToUpload"
                      class="file-input"
                      type="file"
                      @change="handleFileChange"
                    />
                    <span class="file-cta">
                      <span class="file-icon">
                        <i class="icon icon-upload"></i>
                      </span>
                      <span class="file-label">
                        Upload
                      </span>
                    </span>
                    <span class="file-name">
                      {{ (fileBlob && fileBlob.name) || 'No file selected' }}
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <div class="has-text-centered pt-15" v-if="isCreate">
        <button
          class="button is-primary"
          @click="
            handleSubmit(() => {
              $emit('create', buttons, fileBlob);
            })
          "
        >
          Create Project
        </button>
      </div>
    </tab>
    <tab
      v-show="!isCreate"
      title="Additional Features (OPTIONAL)"
      number="2"
      :active="activeTab == 1"
      :done="done[1] || false"
      @click:header="changeTab(1)"
    >
      <validation-observer ref="tab-0" tag="div" class="columns is-multiline">
        <div class="column is-4">
          <div class="field">
            <validation-provider v-slot="{ errors, failed }" rules="required">
              <label class="label">Project Lead - owner of the project</label>
              <div class="control">
                <div class="select" :class="{ 'is-danger': failed }">
                  <select v-model="model.projectLeadUserID">
                    <option
                      v-for="user in $store.getters['users/list']"
                      :value="user.userID"
                    >
                      {{ user.firstName }}
                      {{ user.lastName }}
                      -
                      {{ user.email }}
                    </option>
                  </select>
                </div>
              </div>
              <p class="help is-danger">{{ errors[0] }}</p>
            </validation-provider>
          </div>
        </div>
        <div class="column is-9"></div>
        <div class="column is-12">
          <div class="field">
            <validation-provider v-slot="{ errors, failed }" rules="required">
              <label class="label">Project Description</label>
              <div class="control">
                <textarea
                  v-model="model.description"
                  class="textarea"
                  :class="{ 'is-danger': failed }"
                ></textarea>
              </div>
              <p class="help is-danger">{{ errors[0] }}</p>
            </validation-provider>
          </div>
        </div>

        <div class="column is-12">
          <div class="field">
            <div class="control">
              <app-checkbox v-model="hasButtons">
                Submit Form Response
              </app-checkbox>
              <div class="help">
                Link a form to your project so project team members can easily
                send in responses
              </div>
            </div>
          </div>
        </div>

        <div class="group-step-2 columns column is-12" v-if="hasButtons">
          <div class="column is-8">
            <button-list-manage v-model="buttons"></button-list-manage>
          </div>
          <div class="column is-4">
            <div class="image-placeholder"></div>
          </div>
        </div>
      </validation-observer>
    </tab>
    <div class="has-text-centered pt-15" v-if="!isCreate">
      <button
        class="button is-primary"
        @click="
          handleSubmit(function() {
            $emit('update', buttons);
          })
        "
      >
        Update Project
      </button>
    </div>
  </validation-observer>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import Form from './Form.js';
import AppCheckbox from '../AppCheckbox.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ButtonListManage from '@/components/ButtonListManage.vue';
// import { required } from 'vee-validate/dist/rules';
import '@/validation.js';
import Tab from '@/components/tabs/Tab.vue';
import FilesHelper from '@/mixins/Files.js';

export default {
  name: 'ProjectFormTabs',
  components: {
    ValidationProvider,
    ValidationObserver,
    Tab,
    AppCheckbox,
    ButtonListManage
  },
  extends: Form,
  mixins: [FilesHelper],
  props: {
    resetWatch: {}
  },
  data() {
    return {
      model: {
        coverHtmlColor1: '',
        coverImageContentUrl: ''
      },
      activeTab: 0,
      done: {},
      buttons: []
    };
  },
  computed: {
    hasButtons: {
      get() {
        return this.buttons.length > 0;
      },
      set(newValue) {
        console.log('hasButtons set ', this.buttons);
        if (newValue && this.buttons.length == 0) {
          this.buttons.push({
            title: '',
            titleLink: '',
            groupID: '',
            organizationID: this.model.organizationID
          });
        } else {
          this.buttons = [];
        }
      }
    },
    date() {
      return moment(this.model.createdOnUTC).format('YYYY-MM-DD');
    },
    isCreate() {
      return !this.model.projectID;
    },
    associatedGroup() {
      if (this.hasRole('ueg')) {
        return this.$store.getters['groups/flatTree'](
          -1,
          this.$route.params.organizationID
        );
      } else {
        return this.$store.getters['groups/flatTree']();
      }
    },
    previewProjectColor() {
      if (this.model.coverHtmlColor1) {
        return 'is-gradient-' + this.model.coverHtmlColor1;
      }
      return '';
    },
    previewProjectImage() {
      if (this.model.coverImageContentUrl) {
        return 'background-image: url(' + this.model.coverImageContentUrl + ')';
      }
      return '';
    }
  },
  watch: {
    model(value, oldValue) {
      console.log('changed value ', JSON.stringify(value.buttons));
      if (value) {
        let buttons = [];

        if (value.buttons) {
          for (let i = 0; i < value.buttons.length; i++) {
            buttons.push(value.buttons[i]);
          }
        }

        if (buttons.length > 0) {
          console.log('changed buttons too');
          this.buttons = buttons;
        } else {
          this.buttons = [];
          this.fileBlob = null;
        }
      } else {
        this.buttons = [];
        this.fileBlob = null;
      }
      if (oldValue.projectID && oldValue.projectID != value.projectID) {
        this.activeTab = 0;
      } else if (!oldValue.projectID && value.projectID) {
        this.changeTab(1);
      }
      //this.activeTab = 0;
    }
  },
  methods: {
    async handleFileChange(e) {
      this.fileBlob = this.$refs.fileToUpload.files[0];

      if (this.model.projectID) {
        this.uploadCover(this.fileBlob, this.model);
      } else {
        this.$refs['tab-0'].validate().then(valid => {
          if (valid) {
            console.log('its create  and is valid');
          }
        });
        this.$set(
          this.model,
          'coverImageContentUrl',
          URL.createObjectURL(this.fileBlob)
        );
      }
    },
    pickColor(color) {
      console.log('pick color ', color);
      if (color) {
        if (this.model.coverHtmlColor1 == color)
          this.$set(this.model, 'coverHtmlColor1', '');
        else this.$set(this.model, 'coverHtmlColor1', color);
      } else {
        this.$set(this.model, 'coverHtmlColor1', '');
      }
    },
    validateTab(ref, callback) {
      this.$refs[ref].validate().then(valid => {
        if (valid) {
          callback();
        }
      });
    },
    async changeTab(idx) {
      console.log('changeTab', idx, this.activeTab);
      if (idx == this.activeTab) {
        // is the same tab, do nothing
        return;
      }
      /*if (idx > this.activeTab) {
        // the requested tab is bigger so we must validate all tabs in between
        for (let i = 0; i < idx; i++) {
          const ref = `tab-${i}`;
          if (this.$refs[ref] != undefined) {
            const valid = await this.$refs[ref].validate();
            if (valid) {
              this.$set(this.done, i, true);
            } else {
              this.activeTab = i;
              console.log('active tab ', i);
              return;
            }
          }
        }
      } else {
        // we are going back in steps so all should be undone
        for (const key in this.done) {
          if (this.done.hasOwnProperty(key)) {
            this.$set(this.done, key, false);
          }
        }
      }*/
      console.log('active tab end', idx);
      this.activeTab = idx;
    }
  }
};
</script>
<style lang="scss">
.project-form-tab {
  .group-step-2 {
    padding-left: 36px;
  }

  .help {
    padding-left: 26px;
  }

  .image-placeholder {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 190px;
    background: url('../../assets/images/button-preview-project.png') 50% 50%
      no-repeat;
    background-size: cover;
  }

  .cover-picker {
    display: flex;
    height: 45px;

    .cover-picker-item {
      width: 32px;
      height: 32px;
      border-radius: 16px;
      border: solid 1px #000000;
      margin-right: 4px;
      cursor: pointer;

      &.is-selected {
        border: solid 2px $primary;
      }
    }
  }
}
</style>
